export enum AttributionType {
    Unknown = 'Unknown',
    TeamAttribution = 'TeamAttribution',
    GroupRemittance = 'GroupRemittance',
    GroupAttribution = 'GroupAttribution',
}
